import { Component, Input } from '@angular/core';

@Component({
  selector: 'notification-base',
  template: `<h5 class="notification-item-content-data-title" [innerHTML]="text"></h5>`
})
export class NotificationBaseComponent {
  @Input() text: string;
}
